import { safeApiRequest } from './apiClient';

const BASE = '/api/admin/monitor';

// Not: buildQueryString arama metnini temizlediği için (/, . gibi karakterler path aramasında gerekli)
// query burada elle kuruluyor.
const qs = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && String(v).trim() !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v).trim())}`);
  return parts.length ? `?${parts.join('&')}` : '';
};

export const fetchMonitorIstekler = async (params) =>
  safeApiRequest(`${BASE}/istekler${qs(params)}`, { method: 'GET', skipCsrf: true });

export const fetchMonitorOzet = async (saat = 24) =>
  safeApiRequest(`${BASE}/ozet${qs({ saat })}`, { method: 'GET', skipCsrf: true });
